export const ORDER_BUTTON_CLICKED = 'ORDER_BUTTON_CLICKED';
export const PLACE_ORDER = 'ORDER_PLACE_ORDER';
export const ERROR_PLACE_ORDER = 'ERROR_PLACE_ORDER';
export const AUTH_NET_TOKENIZATION = 'AUTH_NET_TOKENIZATION';
export const REMOVE_BEARER = 'REMOVE_BEARER';
export const REMOVE_CVC = 'REMOVE_CVC';



// WEBPACK FOOTER //
// ./src/actions/order/types.js